import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { ButtonWithIcon } from '@oy/uidesktop';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { useEnv, useProductActiveV2, useTranslate } from 'src/hooks';
import { CLAIM_FUND_CREATE_URL } from 'src/pages/Disbursement/ClaimFund/List/constants';

const ClaimFundCreateButton = () => {
  const { getTranslation } = useTranslate();
  const { isProdEnv } = useEnv();
  const { checkActive } = useProductActiveV2();

  const enableButton = () => {
    // always enable in non-prod env
    return !isProdEnv || checkActive('CLAIM_FUND');
  };

  return (
    <>
      <Link id="btnCreateClaimFund" to={CLAIM_FUND_CREATE_URL}>
        <ButtonWithIcon
          data-tooltip-id="create-claimfund-disabled-tooltip"
          data-tooltip-content={
            !enableButton()
              ? getTranslation('claimFund_disabledCreateButtonTooltip')
              : undefined
          }
          data-tooltip-place="bottom"
          iconName="add"
          disabled={!enableButton()}
          onClick={() => {
            AnalyticsManager.instance().track(AnalyticsEvent.create_claim_fund);
          }}
        >
          {getTranslation('pageTitle_createClaimFund')}
        </ButtonWithIcon>
      </Link>
      <Tooltip
        place="bottom"
        style={{
          zIndex: 9999,
          fontSize: '12px',
          maxWidth: '250px',
        }}
        id="create-claimfund-disabled-tooltip"
      />
    </>
  );
};

export default ClaimFundCreateButton;
